import { FC, useCallback, useMemo } from 'react';
import toast from 'react-hot-toast';
import { useCreateBroadcast } from 'features/broadcast/create-broadcast';
import { useUpdateBroadcastCustomerRestrictions } from 'entities/broadcast-customer-restrictions';
import { useModalContext } from 'shared/lib/modal';
import { DoneIcon } from 'shared/ui';
import { ModalContent } from 'shared/ui/modal-content';
import { useManualBroadcastState } from '../../lib';
import { ManualBroadcast } from '../manual-broadcast/manual-broadcast';
import { ManualBroadcastModalFooter } from '../manual-broadcast-modal-footer';

export const AddBroadcastModalContent: FC = () => {
  const { closeModal } = useModalContext();
  const { createBroadcastMutation } = useCreateBroadcast();
  const { updateBroadcastCustomerRestrictionsMutation } =
    useUpdateBroadcastCustomerRestrictions();
  const { changeHandler, newBroadcastData, newBroadcastRestrictionsData } =
    useManualBroadcastState();

  const canProceed = useMemo(
    () =>
      Boolean(
        newBroadcastData.sportId &&
          newBroadcastData.startDate &&
          newBroadcastData.streamType &&
          newBroadcastData.url &&
          newBroadcastData.title,
      ),
    [newBroadcastData],
  );

  const onSubmit = useCallback(async () => {
    createBroadcastMutation.mutate(
      {
        sportId: newBroadcastData.sportId!,
        startDate: newBroadcastData.startDate!,
        streamType: newBroadcastData.streamType!,
        title: newBroadcastData.title!,
        url: newBroadcastData.url!,
      },
      {
        onSuccess(broadcast) {
          updateBroadcastCustomerRestrictionsMutation.mutate(
            {
              broadcastId: broadcast.id,
              restrictions: newBroadcastRestrictionsData,
            },
            {
              onSuccess() {
                toast(`Трансляция успешно добавлена`, {
                  icon: <DoneIcon />,
                });
                closeModal();
              },
            },
          );
        },
      },
    );
  }, [
    closeModal,
    createBroadcastMutation,
    newBroadcastData,
    newBroadcastRestrictionsData,
    updateBroadcastCustomerRestrictionsMutation,
  ]);

  return (
    <ModalContent
      $title="Добавить трансляцию"
      footer={
        <ManualBroadcastModalFooter
          canProceed={canProceed}
          isLoading={
            createBroadcastMutation.isPending ||
            updateBroadcastCustomerRestrictionsMutation.isPending
          }
          proceedTitile="Добавить"
          onSubmit={onSubmit}
        />
      }
    >
      <ManualBroadcast onChange={changeHandler} />
    </ModalContent>
  );
};
